import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BreadcrumbParent, getDetailRetailer } from '../retailer.data';
import { UtilitiesService } from '@services/utilities.service';
import { RetailerService } from '../retailer.service';
import { ICardDetailBody } from '@models/card.model';
import { EnumRetailerType } from '../enum/retailer.enum';
import { IListboxRegion } from '@shared/components/form/input-listbox-region/input-listbox-region.interface';
import { ModalConfirmRegisterComponent } from '../components/modal-confirm-register/modal-confirm-register.component';
import { STRING_CONSTANTS } from '@config/constants/string.constants';

@Component({
  selector: 'app-mac-registration',
  templateUrl: './mac-registration.component.html',
  styleUrls: ['./mac-registration.component.scss'],
})
export class MacRegistrationComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];

  links: PageLink[] = BreadcrumbParent;
  isLoading = new BehaviorSubject(false);
  detailRetailerInfo: ICardDetailBody[];
  formRegisterMAC = this.retailerService.MacFormRegister;

  @ViewChild('modalConfirmRegister') modalConfirmRegister: ModalConfirmRegisterComponent;

  get npwpImageValue() {
    return this.formRegisterMAC.get('npwp_image_url')?.value as string;
  }

  get npwpControl() {
    return this.formRegisterMAC.get('npwp');
  }

  constructor(
    private pageInfoService: PageInfoService,
    private activatedRoute: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private retailerService: RetailerService
  ) {}

  ngOnInit(): void {
    this.getRetailerDetail();
  }

  getRetailerDetail() {
    if (!this.retailerDataIsEmpty()) {
      return this.initPageDetail();
    }

    this.isLoading.next(true);
    const _detailSubs = this.retailerService.getDetailById(this.getParamID()).subscribe((res) => {
      if (!res) return;
      this.retailerService.RetailerDetail = res.data;
      this.initPageDetail();
      this.isLoading.next(false);
    });

    this.unsubscribe.push(_detailSubs);
  }

  initPageDetail() {
    this.initPageInfo();
    this.initForm();
    this.generateRetailerInfoCard();
  }

  initPageInfo() {
    this.pageInfoService.updateTitle('Registrasi MAC', undefined, false);

    const statusTitle = this.utilitiesService.toCapitalize(this.getParamStatus());
    const _dataSubs = this.retailerService.detailRetailer$.subscribe((resp) => {
      if (!resp) {
        return;
      }

      const { venture_name } = resp;
      const nameTitle = this.utilitiesService.toCapitalize(venture_name);
      const separator = {
        title: '',
        path: '',
        isActive: false,
        isSeparator: true,
      };

      this.pageInfoService.updateBreadcrumbs([
        ...this.links,
        {
          title: `${statusTitle}`,
          path: `/retailer/${this.getParamStatus()}`,
          isActive: false,
        },
        separator,
        {
          title: `${nameTitle}`,
          path: `/retailer/${this.getParamStatus()}/${this.getParamID()}`,
          isActive: false,
        },
        separator,
        {
          title: 'Registrasi MAC',
          path: '',
          isActive: true,
        },
      ]);
    });

    this.unsubscribe.push(_dataSubs);
  }

  initForm() {
    this.retailerService.MacFormRegister.reset();

    this.npwpToggleInput();
    this.formRegisterMAC.patchValue({
      retailer_id: this.getParamID(),
    });

    if (!this.retailerIsR1()) return;

    const { npwp, npwp_image_url } = this.retailerService.RetailerDetail;

    this.formRegisterMAC.patchValue({
      npwp,
      npwp_image_url,
    });
  }

  handleImageUrl = (e: BehaviorSubject<string>) => this.formRegisterMAC.patchValue({ npwp_image_url: e.value });

  npwpToggleInput = () => (this.retailerIsR1() ? this.npwpControl?.disable() : this.npwpControl?.enable());

  handleOutputChips(items: IListboxRegion[]) {
    const selectedID = this.retailerService.mapSelectedID(items);
    this.retailerService.MacSelectedRegion = items;
    this.formRegisterMAC.patchValue({
      sub_district_id: selectedID,
    });
  }

  handleSubmit = () => this.modalConfirmRegister.openDialog();

  handleCancel = () => this.retailerService.goToRetailerDetail(this.getParamID(), this.getParamStatus());

  getNpwpImage = () => ({ url: this.npwpImageValue });

  generateRetailerInfoCard() {
    return (this.detailRetailerInfo = getDetailRetailer(this.retailerService.RetailerDetail));
  }

  retailerIsR1 = () => this.retailerService.RetailerDetail.type === EnumRetailerType.R1;

  isValidForms = () => this.formRegisterMAC.valid;

  getParamID = () => this.activatedRoute.snapshot.queryParams.id;

  getParamStatus = () => this.activatedRoute.snapshot.queryParams.status;

  retailerDataIsEmpty = () => !Object.keys(this.retailerService.RetailerDetail).length;

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
